// Desktop product page (templates/product.liquid): the [data-buy-align] group (title at the top, buy box pushed
// to the bottom with mt-auto) gets a min-height that runs from its own top to the bottom of the first product
// photo, so the payment buttons end level with the photo. When the content is taller than the photo, the
// min-height simply has no effect and the column flows as before. Phones skip this; the group dissolves there.
const desktop = window.matchMedia('(min-width: 48rem)');

function photo() {
  return document.querySelector('[data-product-gallery] > :not([hidden]) .aspect-square, [data-product-gallery] > .aspect-square');
}

function align() {
  const group = document.querySelector('[data-buy-align]');
  if (!group) return;
  const media = photo();
  if (!desktop.matches || !media) {
    group.style.removeProperty('min-height');
    return;
  }
  // The group starts at the top of the product grid (it heads the sticky column), so measure from the grid,
  // which never moves while the column sticks. Clear first so the group's own height can't feed back in.
  group.style.removeProperty('min-height');
  const grid = group.closest('.product-grid') ?? group;
  const height = media.getBoundingClientRect().bottom - grid.getBoundingClientRect().top;
  if (height > 0) group.style.minHeight = `${Math.round(height)}px`;
}

let frame = 0;
function schedule() {
  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(align);
}

const resize = new ResizeObserver(schedule);
function watch() {
  resize.disconnect();
  const media = photo();
  const group = document.querySelector('[data-buy-align]');
  if (media) resize.observe(media);
  if (group?.parentElement) resize.observe(group.parentElement);
  schedule();
}

desktop.addEventListener('change', schedule);
window.addEventListener('load', schedule);
// The gallery partial is swapped on variant change; re-attach to the new photo.
new MutationObserver((records) => {
  if (records.some((r) => r.target.closest?.('[data-product-gallery]') || [...r.addedNodes].some((n) => n.querySelector?.('[data-product-gallery]')))) watch();
}).observe(document.body, { childList: true, subtree: true });
watch();
